import { combineReducers } from 'redux';

import authError from './authError';
import data from './data';
import impersonate from './impersonate';
import isInit from './isInit';
import isLoading from './isLoading';

/**
 * @typedef {import('../../types/currentUser').CurrentUserState} CurrentUserReducer
 */

export default combineReducers({
  data,
  isInit,
  authError,
  isLoading,
  impersonate,
});
